// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dh-pc-section {
  background: transparent;
  padding: 20px;
  overflow: hidden;
}

.dh-pc-personal-section {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

.dh-pc-section-header {
  margin-bottom: 24px;
  margin-left: 8px;
  margin-top: 4px;
}

.dss-title {
  font-size: 24px;
  font-weight: 700;
  color: #002FA7;
  margin: 0 0 8px 0;
}

.dss-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.dh-pc-main-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 700px;
  gap: 24px;
  padding: 8px;
  align-items: stretch;
}

.dh-pc-content-left {
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.dh-pc-personal-content {
  padding: 24px;
  flex: 1 1;
}

.dh-pc-profile-details {
  margin-bottom: 0;
}

.dh-pc-detail-group-title {
  color: #002FA7;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
}

.dh-pc-detail-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.dh-pc-detail-field:last-child {
  margin-bottom: 0;
}

.dh-pc-detail-field label {
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dh-pc-detail-field p {
  color: #1e293b;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  padding: 8px 0;
}

.dh-pc-field-non-editable {
  color: #94a3b8 !important;
  font-style: italic;
}

.dh-pc-field-editable {
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 15px;
  color: #1e293b;
  transition: all 0.2s ease;
  background: #ffffff;
  font-family: inherit;
  box-sizing: border-box;
}

.dh-pc-field-editable:focus {
  outline: none;
  border-color: #5986f7;
  box-shadow: 0 0 0 3px rgba(89, 134, 247, 0.1);
}

.dh-pc-field-editable.pc-error {
  border-color: #ef4444;
}

.dh-pc-field-editable:disabled {
  background-color: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
}

.dh-pc-error-text {
  color: #ef4444;
  font-size: 12px;
  margin-top: 6px;
  display: block;
}

.dh-pc-profile-footer {
  margin-top: 0;
  padding: 20px 24px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

.dh-pc-header-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.dh-pc-edit-btn,
.dh-pc-password-btn,
.dh-pc-save-btn,
.dh-pc-cancel-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  border: 1px solid #8aa3c4b8;
  background: white;
  color: #002FA7;
  flex: 1 1;
}

.dh-pc-edit-btn:hover,
.dh-pc-password-btn:hover,
.dh-pc-save-btn:hover,
.dh-pc-cancel-btn:hover {
  transform: translateY(-2px);
}

.dh-pc-content-right {
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 24px;
  height: 100%;
}

.dh-pc-documents-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e2e8f0;
}

.dh-pc-documents-title {
  color: #002FA7;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.dh-pc-upload-doc-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  border: 1px solid #8aa3c4b8;
  background: white;
  color: #002FA7;
  margin-left: 8px;
}

.dh-pc-upload-doc-btn:hover {
  transform: translateY(-2px);
}

.dh-pc-documents-table-container {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  height: 550px;
}

.dh-pc-documents-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.dh-pc-documents-table thead tr {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 2px solid #e2e8f0;
}

.dh-pc-documents-table th {
  text-align: left;
  padding: 16px 20px;
  font-weight: 500;
  color: #1e40af;
  font-size: 14px;
}

.dh-pc-documents-table th:first-child {
  border-right: 1px solid #e2e8f0;
}

.dh-pc-documents-table td {
  padding: 14px 20px;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: middle;
}

.dh-pc-doc-category-row td {
  padding: 0;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.dh-pc-doc-category-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: #f8fafc;
  cursor: pointer;
}

.dh-pc-doc-category-header:hover {
  background: #f1f5f9;
}

.dh-pc-doc-category-icon {
  font-size: 20px;
}

.dh-pc-doc-category-name {
  font-weight: 700;
  color: #002FA7;
  font-size: 15px;
}

.dh-pc-doc-name-cell {
  border-right: 1px solid #e2e8f0;
  min-width: 290px;
}

.dh-pc-doc-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dh-pc-doc-icon {
  font-size: 24px;
}

.dh-pc-doc-name {
  font-weight: 500;
  color: #0f2c89;
  font-size: 14px;
  word-break: break-word;
}

.dh-pc-doc-meta {
  font-size: 12px;
  color: #94a3b8;
  margin-left: 8px;
}

.dh-pc-doc-actions-cell {
  width: 260px;
}

.dh-pc-doc-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.dh-pc-doc-download,
.dh-pc-doc-print,
.dh-pc-doc-delete {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 24px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dh-pc-doc-download {
  background: #ffffff;
  color: #002FA7;
  border: 1px solid #002FA7;
}

.dh-pc-doc-download:hover {
  background: #dbeafe78;
  transform: translateY(-1px);
}

.dh-pc-doc-delete {
  background: #ffffff;
  color: #b13232;
  border: 1px solid #b13232;
}

.dh-pc-doc-delete:hover {
  background: #f7cccc54;
  transform: translateY(-1px);
}

.dh-pc-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: dh-pc-fadeIn 0.2s ease;
}

@keyframes dh-pc-fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.dh-pc-modal-content {
  background: white;
  border-radius: 24px;
  width: 90%;
  max-width: 480px;
  max-height: 90vh;
  overflow: hidden;
  animation: dh-pc-modal-appear 0.3s ease-out;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

@keyframes dh-pc-modal-appear {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.dh-pc-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px 20px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
}

.dh-pc-modal-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: white;
}

.dh-pc-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  font-size: 28px;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.dh-pc-modal-close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.dh-pc-modal-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dh-pc-password-form {
  padding: 28px;
}

.dh-pc-form-field {
  margin-bottom: 24px;
}

.dh-pc-form-field label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
}

.dh-pc-form-field input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.2s ease;
  font-family: inherit;
  box-sizing: border-box;
}

.dh-pc-form-field input:focus {
  outline: none;
  border-color: #5986f7;
  box-shadow: 0 0 0 3px rgba(89, 134, 247, 0.1);
}

.dh-pc-form-field input:disabled {
  background-color: #f1f5f9;
  cursor: not-allowed;
}

.dh-pc-modal-actions {
  display: flex;
  gap: 12px;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.dh-pc-btn-primary,
.dh-pc-btn-secondary {
  flex: 1 1;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.dh-pc-btn-primary {
  background: linear-gradient(135deg, #002FA7 0%, #1e40af 100%);
  color: white;
}

.dh-pc-btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #1e40af 0%, #002FA7 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);
}

.dh-pc-btn-secondary {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.dh-pc-btn-secondary:hover:not(:disabled) {
  background: #e2e8f0;
  transform: translateY(-2px);
}

.dh-pc-btn-primary:disabled,
.dh-pc-btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.dh-pc-loading {
  text-align: center;
  padding: 60px 20px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
}

.dh-pc-loading p {
  color: #64748b;
  font-size: 16px;
  margin: 0;
}

.dh-pc-loading-documents {
  text-align: center;
  padding: 40px;
  color: #666;
}

.dh-pc-no-documents {
  text-align: center;
  padding: 40px;
  color: #666;
}

.dh-pc-no-documents-hint {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.dh-pc-not-authorized {
  text-align: center;
  padding: 60px 20px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
}

.dh-pc-not-authorized h3 {
  color: #ef4444;
  margin-bottom: 12px;
}

.dh-pc-not-authorized p {
  color: #64748b;
}

.dh-pc-documents-table tbody tr:hover {
  background-color: #cce1fc2c;
}

.dh-pc-doc-date-cell {
  text-align: center;
  white-space: nowrap;
  font-size: 13px;
  color: #555;
}

@media (max-width: 1100px) {
  .dh-pc-main-content {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  
  .dh-pc-content-left,
  .dh-pc-content-right {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .dh-pc-section-header {
    padding: 0 4px 16px 4px;
  }
  
  .dh-pc-personal-section {
    padding: 12px;
  }
  
  .dh-pc-section {
    padding: 12px;
  }
  
  .dss-title {
    font-size: 24px;
  }
  
  .dh-pc-personal-content {
    padding: 16px;
  }
  
  .dh-pc-detail-group {
    padding: 16px;
  }
  
  .dh-pc-profile-footer {
    padding: 16px;
  }
  
  .dh-pc-header-actions {
    flex-direction: column;
  }
  
  .dh-pc-edit-btn,
  .dh-pc-password-btn,
  .dh-pc-save-btn,
  .dh-pc-cancel-btn {
    width: 100%;
  }
  
  .dh-pc-content-right {
    padding: 16px;
  }
  
  .dh-pc-documents-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .dh-pc-doc-actions-cell {
    width: auto;
  }
  
  .dh-pc-doc-actions {
    flex-direction: column;
  }
  
  .dh-pc-doc-download,
  .dh-pc-doc-print,
  .dh-pc-doc-delete {
    justify-content: center;
    width: 100%;
  }
  
  .dh-pc-doc-name {
    font-size: 13px;
  }
  
  .dh-pc-doc-meta {
    display: block;
    margin-left: 0;
    margin-top: 4px;
  }
  
  .dh-pc-doc-info {
    flex-wrap: wrap;
  }
  
  .dh-pc-modal-content {
    width: 95%;
    margin: 16px;
  }
  
  .dh-pc-password-form {
    padding: 20px;
  }
  
  .dh-pc-modal-actions {
    flex-direction: column;
  }
  
  .dh-pc-btn-primary,
  .dh-pc-btn-secondary {
    width: 100%;
  }
  
  .dh-pc-doc-date-cell {
    display: none;
  }
  
  .dh-pc-documents-table th:nth-child(2),
  .dh-pc-documents-table td:nth-child(2) {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/dh-components/PersonalCabinetSectionStyle.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,SAAS;EACT,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,SAAO;AACT;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".dh-pc-section {\n  background: transparent;\n  padding: 20px;\n  overflow: hidden;\n}\n\n.dh-pc-personal-section {\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.dh-pc-section-header {\n  margin-bottom: 24px;\n  margin-left: 8px;\n  margin-top: 4px;\n}\n\n.dss-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #002FA7;\n  margin: 0 0 8px 0;\n}\n\n.dss-subtitle {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0;\n}\n\n.dh-pc-main-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  height: 700px;\n  gap: 24px;\n  padding: 8px;\n  align-items: stretch;\n}\n\n.dh-pc-content-left {\n  background: #ffffff;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.dh-pc-personal-content {\n  padding: 24px;\n  flex: 1;\n}\n\n.dh-pc-profile-details {\n  margin-bottom: 0;\n}\n\n.dh-pc-detail-group-title {\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.dh-pc-detail-field {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n}\n\n.dh-pc-detail-field:last-child {\n  margin-bottom: 0;\n}\n\n.dh-pc-detail-field label {\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dh-pc-detail-field p {\n  color: #1e293b;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0;\n  padding: 8px 0;\n}\n\n.dh-pc-field-non-editable {\n  color: #94a3b8 !important;\n  font-style: italic;\n}\n\n.dh-pc-field-editable {\n  width: 100%;\n  padding: 10px 14px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 15px;\n  color: #1e293b;\n  transition: all 0.2s ease;\n  background: #ffffff;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.dh-pc-field-editable:focus {\n  outline: none;\n  border-color: #5986f7;\n  box-shadow: 0 0 0 3px rgba(89, 134, 247, 0.1);\n}\n\n.dh-pc-field-editable.pc-error {\n  border-color: #ef4444;\n}\n\n.dh-pc-field-editable:disabled {\n  background-color: #f1f5f9;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.dh-pc-error-text {\n  color: #ef4444;\n  font-size: 12px;\n  margin-top: 6px;\n  display: block;\n}\n\n.dh-pc-profile-footer {\n  margin-top: 0;\n  padding: 20px 24px;\n  border-top: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.dh-pc-header-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.dh-pc-edit-btn,\n.dh-pc-password-btn,\n.dh-pc-save-btn,\n.dh-pc-cancel-btn {\n  padding: 10px 24px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n  border: 1px solid #8aa3c4b8;\n  background: white;\n  color: #002FA7;\n  flex: 1;\n}\n\n.dh-pc-edit-btn:hover,\n.dh-pc-password-btn:hover,\n.dh-pc-save-btn:hover,\n.dh-pc-cancel-btn:hover {\n  transform: translateY(-2px);\n}\n\n.dh-pc-content-right {\n  background: #ffffff;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n  height: 100%;\n}\n\n.dh-pc-documents-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.dh-pc-documents-title {\n  color: #002FA7;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.dh-pc-upload-doc-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n  border: 1px solid #8aa3c4b8;\n  background: white;\n  color: #002FA7;\n  margin-left: 8px;\n}\n\n.dh-pc-upload-doc-btn:hover {\n  transform: translateY(-2px);\n}\n\n.dh-pc-documents-table-container {\n  overflow-x: auto;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  height: 550px;\n}\n\n.dh-pc-documents-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n}\n\n.dh-pc-documents-table thead tr {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.dh-pc-documents-table th {\n  text-align: left;\n  padding: 16px 20px;\n  font-weight: 500;\n  color: #1e40af;\n  font-size: 14px;\n}\n\n.dh-pc-documents-table th:first-child {\n  border-right: 1px solid #e2e8f0;\n}\n\n.dh-pc-documents-table td {\n  padding: 14px 20px;\n  border-bottom: 1px solid #e2e8f0;\n  vertical-align: middle;\n}\n\n.dh-pc-doc-category-row td {\n  padding: 0;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dh-pc-doc-category-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  background: #f8fafc;\n  cursor: pointer;\n}\n\n.dh-pc-doc-category-header:hover {\n  background: #f1f5f9;\n}\n\n.dh-pc-doc-category-icon {\n  font-size: 20px;\n}\n\n.dh-pc-doc-category-name {\n  font-weight: 700;\n  color: #002FA7;\n  font-size: 15px;\n}\n\n.dh-pc-doc-name-cell {\n  border-right: 1px solid #e2e8f0;\n  min-width: 290px;\n}\n\n.dh-pc-doc-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dh-pc-doc-icon {\n  font-size: 24px;\n}\n\n.dh-pc-doc-name {\n  font-weight: 500;\n  color: #0f2c89;\n  font-size: 14px;\n  word-break: break-word;\n}\n\n.dh-pc-doc-meta {\n  font-size: 12px;\n  color: #94a3b8;\n  margin-left: 8px;\n}\n\n.dh-pc-doc-actions-cell {\n  width: 260px;\n}\n\n.dh-pc-doc-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dh-pc-doc-download,\n.dh-pc-doc-print,\n.dh-pc-doc-delete {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dh-pc-doc-download {\n  background: #ffffff;\n  color: #002FA7;\n  border: 1px solid #002FA7;\n}\n\n.dh-pc-doc-download:hover {\n  background: #dbeafe78;\n  transform: translateY(-1px);\n}\n\n.dh-pc-doc-delete {\n  background: #ffffff;\n  color: #b13232;\n  border: 1px solid #b13232;\n}\n\n.dh-pc-doc-delete:hover {\n  background: #f7cccc54;\n  transform: translateY(-1px);\n}\n\n.dh-pc-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: dh-pc-fadeIn 0.2s ease;\n}\n\n@keyframes dh-pc-fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.dh-pc-modal-content {\n  background: white;\n  border-radius: 24px;\n  width: 90%;\n  max-width: 480px;\n  max-height: 90vh;\n  overflow: hidden;\n  animation: dh-pc-modal-appear 0.3s ease-out;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n\n@keyframes dh-pc-modal-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.dh-pc-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 28px 20px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n}\n\n.dh-pc-modal-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: white;\n}\n\n.dh-pc-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  font-size: 28px;\n  cursor: pointer;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.dh-pc-modal-close:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.dh-pc-modal-close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dh-pc-password-form {\n  padding: 28px;\n}\n\n.dh-pc-form-field {\n  margin-bottom: 24px;\n}\n\n.dh-pc-form-field label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 14px;\n}\n\n.dh-pc-form-field input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 15px;\n  transition: all 0.2s ease;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.dh-pc-form-field input:focus {\n  outline: none;\n  border-color: #5986f7;\n  box-shadow: 0 0 0 3px rgba(89, 134, 247, 0.1);\n}\n\n.dh-pc-form-field input:disabled {\n  background-color: #f1f5f9;\n  cursor: not-allowed;\n}\n\n.dh-pc-modal-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 32px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.dh-pc-btn-primary,\n.dh-pc-btn-secondary {\n  flex: 1;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.dh-pc-btn-primary {\n  background: linear-gradient(135deg, #002FA7 0%, #1e40af 100%);\n  color: white;\n}\n\n.dh-pc-btn-primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, #1e40af 0%, #002FA7 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);\n}\n\n.dh-pc-btn-secondary {\n  background: #f1f5f9;\n  color: #475569;\n  border: 1px solid #e2e8f0;\n}\n\n.dh-pc-btn-secondary:hover:not(:disabled) {\n  background: #e2e8f0;\n  transform: translateY(-2px);\n}\n\n.dh-pc-btn-primary:disabled,\n.dh-pc-btn-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.dh-pc-loading {\n  text-align: center;\n  padding: 60px 20px;\n  background: #ffffff;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.dh-pc-loading p {\n  color: #64748b;\n  font-size: 16px;\n  margin: 0;\n}\n\n.dh-pc-loading-documents {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.dh-pc-no-documents {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.dh-pc-no-documents-hint {\n  font-size: 12px;\n  color: #999;\n  margin-top: 8px;\n}\n\n.dh-pc-not-authorized {\n  text-align: center;\n  padding: 60px 20px;\n  background: #ffffff;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.dh-pc-not-authorized h3 {\n  color: #ef4444;\n  margin-bottom: 12px;\n}\n\n.dh-pc-not-authorized p {\n  color: #64748b;\n}\n\n.dh-pc-documents-table tbody tr:hover {\n  background-color: #cce1fc2c;\n}\n\n.dh-pc-doc-date-cell {\n  text-align: center;\n  white-space: nowrap;\n  font-size: 13px;\n  color: #555;\n}\n\n@media (max-width: 1100px) {\n  .dh-pc-main-content {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n  \n  .dh-pc-content-left,\n  .dh-pc-content-right {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .dh-pc-section-header {\n    padding: 0 4px 16px 4px;\n  }\n  \n  .dh-pc-personal-section {\n    padding: 12px;\n  }\n  \n  .dh-pc-section {\n    padding: 12px;\n  }\n  \n  .dss-title {\n    font-size: 24px;\n  }\n  \n  .dh-pc-personal-content {\n    padding: 16px;\n  }\n  \n  .dh-pc-detail-group {\n    padding: 16px;\n  }\n  \n  .dh-pc-profile-footer {\n    padding: 16px;\n  }\n  \n  .dh-pc-header-actions {\n    flex-direction: column;\n  }\n  \n  .dh-pc-edit-btn,\n  .dh-pc-password-btn,\n  .dh-pc-save-btn,\n  .dh-pc-cancel-btn {\n    width: 100%;\n  }\n  \n  .dh-pc-content-right {\n    padding: 16px;\n  }\n  \n  .dh-pc-documents-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n  \n  .dh-pc-doc-actions-cell {\n    width: auto;\n  }\n  \n  .dh-pc-doc-actions {\n    flex-direction: column;\n  }\n  \n  .dh-pc-doc-download,\n  .dh-pc-doc-print,\n  .dh-pc-doc-delete {\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .dh-pc-doc-name {\n    font-size: 13px;\n  }\n  \n  .dh-pc-doc-meta {\n    display: block;\n    margin-left: 0;\n    margin-top: 4px;\n  }\n  \n  .dh-pc-doc-info {\n    flex-wrap: wrap;\n  }\n  \n  .dh-pc-modal-content {\n    width: 95%;\n    margin: 16px;\n  }\n  \n  .dh-pc-password-form {\n    padding: 20px;\n  }\n  \n  .dh-pc-modal-actions {\n    flex-direction: column;\n  }\n  \n  .dh-pc-btn-primary,\n  .dh-pc-btn-secondary {\n    width: 100%;\n  }\n  \n  .dh-pc-doc-date-cell {\n    display: none;\n  }\n  \n  .dh-pc-documents-table th:nth-child(2),\n  .dh-pc-documents-table td:nth-child(2) {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
